import { AoInstance } from "./ao"

import { getDataSource } from "../services/data-source"

export type TokenDetailsR = {
  InternalId: string
  Deployer: string
  Name: string
  Ticker: string
  Denomination: number
  Description: string
  Balances: Record<string, number>
  TotalSupply: number
  Telegram: string
  Twitter: string
  Website: string
  Logo: string
  Status: string
  LPs: Record<string, string>
  RenounceOwnership: string | boolean
  TokenProcess?: string
}

export type TokenDetails = {
  InternalId: string
  Deployer: string
  Name: string
  Ticker: string
  Denomination: number
  Description: string
  Balances: Record<string, number>
  TotalSupply: number
  Telegram: string
  Twitter: string
  Website: string
  Logo: string
  Status: string
  LPs: Record<string, string>
  RenounceOwnership: boolean
}

export async function getTokenDetails(
  tokenProcess: string,
  ao: AoInstance,
  _timeout?: number,
): Promise<TokenDetails> {
  const dataSource = getDataSource(ao)
  return await dataSource.getTokenDetails(tokenProcess)
}
